import firebaseApp from '../../firebase/firebase';
import {
  ADD_COMMENT,
  ADD_VA,
  CREATE_PROJECT,
  CREATE_TASK,
  DELETE_PROJECT,
  DELETE_TASK,
  FETCH_PROJECTS,
  FETCH_PROJECTS_ADMIN,
  FETCH_TASKS,
  FETCH_TASKS_ADMIN,
  NO_PROJECTS,
  NO_TASKS,
  NOTIFY_ADMIN,
  SLACK_MESSAGE_SENT,
  USER_FOUND,
  USER_NOT_FOUND,
} from '../../_actions/types';

export const addVirtualAssistant = (email, key) => {
  return dispatch => {
    let va, vaid
    firebaseApp.database().ref('users').on('value', snapshot => {
      const values = snapshot.val();
      if (values) {
        for (const user of Object.values(values)){
          if (email === user.meta.email){
            va = user.meta.email
            vaid = user.meta.id
            }
          }
        }
      })
      if (va && vaid){
        const updates = {}
        updates[`users/${vaid}/projects/${key}`] = true
        updates[`projects/projects/${key}/users/${vaid}`] = va
        firebaseApp.database().ref().update(updates).then(() => {
          dispatch({ type: ADD_VA})
        })
      } else {
        dispatch ({ type: USER_NOT_FOUND })
      }
  }
}

export const addComment = (comment, task, project, timestamp) => {
  return ( dispatch, getState ) => {
    firebaseApp.database().ref(`projects/projects/${project}/users`).on('value', snapshot => {
      const state = getState();
      const user = state.auth.user.email

      const Ref = firebaseApp.database().ref(`projects/projects/${project}/tasks/${task}/comments`).push();
      const Key = Ref.key;
      const updates = {};
      const emailRecipients = snapshot.val()

      updates[`projects/projects/${project}/tasks/${task}/comments/${Key}/comment`] = comment
      updates[`projects/projects/${project}/tasks/${task}/comments/${Key}/timestamp`] = timestamp
      updates[`projects/projects/${project}/tasks/${task}/comments/${Key}/users`] = emailRecipients
      updates[`projects/projects/${project}/tasks/${task}/comments/${Key}/key`] = Key
      updates[`projects/projects/${project}/tasks/${task}/comments/${Key}/poster`] = user

      firebaseApp.database().ref().update(updates)
      .then(() => {
        dispatch ({ type: ADD_COMMENT });
      });
    })
  };
};

export const createProject = ( buyer, address, city, st, zip, email ) => {
  return (dispatch) => {
    let realtor, realtorid
    firebaseApp.database().ref('users').on('value', snapshot => {
      const values = snapshot.val();
      if (values) {
        for (const user of Object.values(values)){
          if (email === user.meta.email){
            realtor = user.meta.email
            realtorid = user.meta.id
            }
          }
        }
      })
      if (realtor && realtorid){
        const Ref = firebaseApp.database().ref(`projects`).push();
        const Key = Ref.key;
        const updates = {};
        updates[`projects/projects/${Key}/location/street`] = address;
        updates[`projects/projects/${Key}/location/city`] = city;
        updates[`projects/projects/${Key}/location/st`] = st;
        updates[`projects/projects/${Key}/location/zip`] = zip;
        updates[`projects/projects/${Key}/location/image`] = "";
        updates[`projects/projects/${Key}/meta/buyer`] = buyer;
        updates[`projects/projects/${Key}/meta/realtor`] = realtor;
        updates[`projects/projects/${Key}/meta/realtorid`] = realtorid;
        updates[`projects/projects/${Key}/meta/task_count`] = 0
        updates[`projects/projects/${Key}/meta/key`] = Key
        updates[`projects/projects/${Key}/users/${realtorid}`] = realtor
        updates[`users/${realtorid}/projects/${Key}`] = true;
        firebaseApp.database().ref().update(updates)
        .then(() => {
          dispatch ({ type: CREATE_PROJECT });
        });
      } else {
        dispatch ({ type: USER_NOT_FOUND })
      }
    }
  }


export const createTask = (task, meta) => {
  return (dispatch, getState) => {
    const projectid = meta.key
    const Ref = firebaseApp.database().ref(`projects/projects/${projectid}/tasks`).push();
    const Key = Ref.key;
    const updates = {};

    updates[`projects/projects/${projectid}/tasks/${Key}/title`] = task
    updates[`projects/projects/${projectid}/tasks/${Key}/key`] = Key
    updates[`projects/projects/${projectid}/tasks/${Key}/done`] = false
    updates[`projects/projects/${projectid}/tasks/${Key}/inprogressuser`] = ""

    firebaseApp.database().ref().update(updates)
    .then(() => {
        firebaseApp.database().ref(`/projects/meta/task_count`)
        .once('value')
        .then((snapshot) => {
          const updates = {};
          updates[`/projects/meta/task_count`] = snapshot.val() + 1;
          firebaseApp.database().ref().update(updates);
        });
    })

    .then(() => {
        firebaseApp.database().ref(`/projects/projects/${projectid}/meta/task_count`)
        .once('value')
        .then((snapshot) => {
          const updates = {};
          updates[`/projects/projects/${projectid}/meta/task_count`] = snapshot.val() + 1;
          firebaseApp.database().ref().update(updates);
        });
    })

    dispatch({ type: CREATE_TASK });
  };
}


export const sendToSlackMarketing = (project,task) => {
    return dispatch => {
    fetch('https://hooks.slack.com/services/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',{
      method:'POST',
      body: JSON.stringify({
      'text':
  `NEW TASK
  Task Title: ${task.title},
  Property: ${project.location.street}
  Due Date: ${task.duedate}
  ______________________________
  `,
      })
    }).then(()=>{
      dispatch({ type: SLACK_MESSAGE_SENT})
    })
  }
}

export const sendToSlackScheduling = (project,task) => {
  return dispatch => {
    fetch('https://hooks.slack.com/services/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',{
      method:'POST',
      body: JSON.stringify({
      'text':
  `NEW TASK
  Task Title: ${task.title},
  Property: ${project.location.street}
  Due Date: ${task.duedate}
  ______________________________
  `,
      })
    }).then(()=>{
      dispatch({ type: SLACK_MESSAGE_SENT})
    })
  }
}

export const sendToSlackContracts = (project,task) => { 
  return dispatch => {
    fetch('https://hooks.slack.com/services/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',{
      method:'POST',
      body: JSON.stringify({
      'text':
  `NEW TASK
  Task Title: ${task.title},
  Property: ${project.location.street}
  Due Date: ${task.duedate}
  ______________________________
  `,
      })
    }).then(()=>{
      dispatch({ type: SLACK_MESSAGE_SENT})
    })
  }
}

export const notifyAdmin = (va, client, location, task) => {
  return dispatch => {
  fetch("https://hooks.slack.com/services/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",{
    method:'POST',
    body: JSON.stringify({
    'text':
`TASK STARTED
Task Title: ${task.title},
Property: ${location}
Due Date: ${task.duedate}
VA: ${va.email}
Client: ${client}
______________________________
`,
    })
  }).then(()=>{
    dispatch({ type: NOTIFY_ADMIN})
  })
}
}

export const deleteProject = (meta, users) => {
  return ( dispatch, getState ) => {
    const state = getState();
    const id = state.auth.user.uid;
    const projectid = meta.key

    /* The order right here matters!! */
    for (const user of Object.keys(users)) {
      firebaseApp.database().ref(`users/${user}/projects/${projectid}`).remove();
    }
    firebaseApp.database().ref(`projects/projects/${projectid}`).remove();
    dispatch({ type: DELETE_PROJECT})
  }
}

export const deleteTask = (task, meta) => {
  return (dispatch, getState) => {
    const projectid = meta.key
    const taskid = task.key

    firebaseApp.database().ref(`projects/projects/${projectid}/tasks/${taskid}`).remove();
    firebaseApp.database().ref(`/projects/projects/${projectid}/meta/task_count`)
    .once('value')
    .then(() => {
        firebaseApp.database().ref(`/projects/meta/task_count`)
        .once('value')
        .then((snapshot) => {
          const updates = {};
          updates[`/projects/meta/task_count`] = snapshot.val() - 1;
          firebaseApp.database().ref().update(updates);
        });
    })
    .then(() => {
        firebaseApp.database().ref(`/projects/projects/${projectid}/meta/task_count`)
        .once('value')
        .then((snapshot) => {
          const updates = {};
          updates[`/projects/projects/${projectid}/meta/task_count`] = snapshot.val() - 1;
          firebaseApp.database().ref().update(updates);
        });
    })
    dispatch({ type: DELETE_TASK });
  };
}

export const loadProjectsFromFirebase = () => {
  return (dispatch, getState) => {
    const state = getState();
    const id = state.auth.user.uid;

    firebaseApp.database().ref(`projects/projects`).on('value', () => {
      firebaseApp.database().ref(`users/${id}/projects`).on('value', snapshot => {
        const values = snapshot.val();
        if (values !== null) {
        const count = Object.values(values).length
        const projects = []
        for (let key of Object.keys(values)) {
          firebaseApp.database().ref(`projects/projects/${key}`).on('value', snapshot => {
            projects.push(snapshot.val());
          });
        };
        dispatch({ type: FETCH_PROJECTS, payload: projects, projectCount: count });
      } else {
        dispatch ({ type: NO_PROJECTS });
      }
    })
    })
  };
};

export const loadAdminProjectsFromFirebase = () => {
  return (dispatch, getState) => {

    firebaseApp.database().ref(`projects/projects`).on('value', snapshot => {
      const values = snapshot.val();
      if (values !== null) {
        const count = Object.values(values).length
        dispatch ({ type: FETCH_PROJECTS_ADMIN, payload: values, projectCount: count })
      } else {
        dispatch ({ type: NO_PROJECTS});
      }
    })
  }
}


export const loadTasksFromFirebase = () => {
  return (dispatch, getState) => {
    const state = getState();
    const id = state.auth.user.uid;

    firebaseApp.database().ref(`projects/projects`).on('value', () => {
      firebaseApp.database().ref(`users/${id}/projects`).on('value', snapshot => {
        const values = snapshot.val();
        if (values) {
        const projects = []
        for (let key of Object.keys(values)) {
          firebaseApp.database().ref(`projects/projects/${key}`).on('value', snapshot => {
            projects.push(snapshot.val());
          });
        };
        const taskPanel = {}
        let count = 0
        for ( let project of Object.values(projects) ) {
          /* See if tasks exist */
          if (project.tasks) {
            /* Iterate through each task */
            for (let task of Object.values(project.tasks)) {
              count = count + 1
                /* Check to see if entry exists */
                if (!taskPanel[task.duedate]) {
                  taskPanel[task.duedate] = []
                }
                /* It exists, just push upon existing stack */
                taskPanel[task.duedate].push(task.title)
            }
          } else {
            dispatch({ type: NO_TASKS })
          }
        }
        dispatch({ type: FETCH_TASKS, payload: taskPanel, count });
      } else {
        dispatch ({ type: NO_PROJECTS });
      }
    })
    })
  };
}

export const loadAdminTasksFromFirebase = () => {
  return ( dispatch, getState ) => {
    firebaseApp.database().ref(`projects/projects/`).on('value', snapshot => {
      const taskPanel = {}
      if (snapshot.val() !== null) {
        /* Get the projects */
        for ( let project of Object.values(snapshot.val()) ) {
          /* See if tasks exist */
          if (project.tasks) {
            /* Iterate through each task */
            for (let task of Object.values(project.tasks)) {
              /* Check to see if task has a duedate */
              /*if (task.duedate) {*/
                /* Check to see if entry exists */
                if (!taskPanel[task.duedate]) {
                  taskPanel[task.duedate] = []
                }
                /* It exists, just push upon existing stack */
                taskPanel[task.duedate].push(task.title)
              /*} else {
                taskPanel['No Due Date'].push(task.title)
              }*/
            }
          }
        }
      }
      dispatch({ type: FETCH_TASKS_ADMIN, payload: taskPanel });
    })
  }
}


export const uploadFile = (task, meta) => {

}

export const uploadImage = () => {

}



// WEBPACK FOOTER //
// ./src/components/project/project_actions.js